import React from 'react';
import { observer, inject } from 'mobx-react';

import RevertButton from 'app/components/BookmarkMenu/RevertButton';
import CancelButton from 'app/components/BookmarkMenu/CancelButton';
import SaveButton from 'app/components/BookmarkMenu/SaveButton';

function AddNoteMenu({ AppState }) {
  if (!AppState.isUserAnnotating) return null;
  return (
    <React.Fragment>
      <RevertButton
        onClick={() => {
          AppState.resetBookmarkingNote();
          AppState.setMenuBar('BOOKMARKING_MENU');
        }}
      />
      <CancelButton />
      <SaveButton />
    </React.Fragment>
  );
}

export default inject('AppState')(observer(AddNoteMenu));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/AddNoteMenu.js